export const extractSiren = (siret: string): string => siret.slice(0, 9);
